// frontend/src/components/TransactionPagination.js
import React from "react";
import { TablePagination } from "@mui/material";

const TransactionPagination = ({
  count,
  page,
  limit,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <TablePagination
    component="div"
    count={count}
    page={page - 1}
    rowsPerPage={limit}
    onPageChange={(event, newPage) => onPageChange(newPage + 1)}
    rowsPerPageOptions={[10, 25, 50]}
    onRowsPerPageChange={(event) =>
      onRowsPerPageChange(parseInt(event.target.value, 10))
    }
  />
);

export default TransactionPagination;
